import { useUser } from '../redux/reducer/user';
import { useContent } from '../redux/reducer/content';
import { useMemo } from 'react';

export const useLevelData = (extraProfile) => {
  const { profile: userProfile } = useUser();
  const { levels, prizes } = useContent();

  return useMemo(() => {
    const profile = extraProfile ?? userProfile;

    if (!profile || !levels || !prizes) return {};

    const thisLevelIndex = levels?.findIndex(({ number }) => number === profile.level);

    const nextLevel = levels[thisLevelIndex + 1];
    const prevLevel = levels[thisLevelIndex - 1];

    return { level: profile.level, levels, levelData: levels[thisLevelIndex], nextLevel, prevLevel };
  }, [levels, userProfile, prizes, extraProfile]);
};
